import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const DeleteIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 20)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M0.697678 4.08008H19.3023" />
      <path d="M11.9033 0.697754H8.09768C7.76116 0.697754 7.43843 0.831435 7.20048 1.06939C6.96252 1.30734 6.82884 1.63007 6.82884 1.96659V4.08008H13.1712V1.96659C13.1712 1.63024 13.0376 1.30764 12.7999 1.06972C12.5621 0.83179 12.2396 0.698001 11.9033 0.697754V0.697754Z" />
      <path d="M8.09767 14.8623V8.52002" />
      <path d="M11.9023 14.8623V8.52002" />
      <path d="M15.8009 18.135C15.7774 18.4529 15.6343 18.7501 15.4004 18.9667C15.1665 19.1833 14.8592 19.3033 14.5405 19.3024H5.4586C5.13982 19.3033 4.83254 19.1833 4.59866 18.9667C4.36478 18.7501 4.22166 18.4529 4.19814 18.135L3.02325 4.08008H16.9767L15.8009 18.135Z" />
    </SVG>
  );
};
